import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrencyPipe } from '@angular/common';
import { SelectItem } from 'primeng/api';
import { ConnectWoocommerceAccountComponent } from '../../gallery-components/connect-woocommerce-account/connect-woocommerce-account.component';
import { ShopifyAccount } from '../../gallery-components/shopify-account/shopify-account.component';
import { AuthService, AuthConfig } from 'src/app/Services/auth.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { ArtistProductsService, ArtistProductsSummaryRequest, ArtistProductSummary, PlatformSyncResult, SyncProductsResponse } from 'src/app/Services/artistproducts.service';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { CategoryService } from 'src/app/Services/category.service';
import { SeriesService } from 'src/app/Services/series.service';
import { ConnectionsService } from 'src/app/Services/connections.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { WoocomerceService, WoocommerceCredentials, StoreDetail } from 'src/app/Services/woocomerce-service/woocomerce.service';
import { ShopifyService, ShopifyOAuthToken, ShopifyStoreAccount } from 'src/app/Services/shopify-service/shopify.service';
import { WixService, AllPlatformCurrencyExchangeRate } from 'src/app/Services/Wix-Service/wix.service';
import { SquareupPosService } from 'src/app/Services/squareup-pos.service.ts/squareup-pos.service';
import { SquareSpaceService } from 'src/app/Services/square-space/square-space.service';
import { CurrencyExchangeService } from '../../gallery-components/consignment-product-selection/platforms-currency-settings-dialogs/CurrencyExchangeService/CurrencyExchange.service';
import { NotificationTypes } from 'src/app/app.enums';
import { ImageUtils } from 'src/app/shared/utils/image-utils';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-sync-products-artist',
    templateUrl: './sync-products-artist.component.html',
    styleUrls: ['./sync-products-artist.component.css'],
    providers: [ArtistsService, ArtistProductsService, SeriesService, CategoryService, SubscriptionRulesService],
    standalone: false
})
export class SyncProductsArtistComponent implements OnInit {
    @ViewChild(ConnectWoocommerceAccountComponent, { static: false }) woocommerceComponent?: ConnectWoocommerceAccountComponent;
    @ViewChild('shopifyComponent', { static: false }) shopifyComponent?: ShopifyAccount;
    // Auth & user
    public authConfig: AuthConfig = {};
    public artistId!: string;
    public isArtist = false;
    public isFreePlanUser = true;
    public loadingSquareSpacePages: boolean = false;
    // UI state
    public loadingArtistProducts = false;
    public visible = false;
    public isStripeDisplayPlansDialogVisible = false;
    public isAddWoocommerceAccountDailogVisible = false;
    public isShopifyConnectionDailogVisible = false;
    public selectedPlatformDailaog = false;
    public displayCurrencyDialog = false;
    public showSyncResultsDialog = false;
    public isLoading = false;
    // Platform accounts
    public shopifyAccount: ShopifyOAuthToken = {} as ShopifyOAuthToken;
    public wooCommerceAccount: WoocommerceCredentials = {} as WoocommerceCredentials;
    public ShopifyStoreAccountList: ShopifyStoreAccount[] = [];
    public wooCommerceAccountList: StoreDetail[] = [];
    public isWoocommerce = false;
    public isShopify = false;
    public isSquareSpaceAccountExists = false;
    // Platform selection
    public selectedWoocommerceStore = '';
    public selectedShopifyStore = '';
    public squareSpaceSiteId = '';
    public squareSpacePageId = '';
    public platformsToSend: { plateform: string; accountId: string }[] = [];
    // Product selection
    public artistProducts: ArtistProductSummary[] = [];
    public selectedProduct: ArtistProductSummary[] = [];
    public selectedGalleryProductsInventory: ArtistProductSummary[] = [];
    public filters: ArtistProductsSummaryRequest = {};
    public artistArtTypes: SelectItem[] = [];
    public galleries: SelectItem[] = [];
    public productCategories: SelectItem[] = [];
    public productSeries: SelectItem[] = [];
    public statusFilterOptions: SelectItem[] = [];
    public currentAvailableArtworks = 0;
    public currencyCode = 'USD';
    // SquareSpace
    public squareSpaceSiteDetails: any[] = [];
    public squareSpaceSitePageDetails: any[] = [];
    // Respose After synced Product Results
    public syncResults = {
        overallSuccess: false,
        overallMessage: '',
        platforms: [] as {
            name: string;
            success: boolean;
            hasWarnings: boolean;
            message: string;
            newSyncedCount: number;
            existingSyncedCount: number;
        }[]
    };

    // Currency
    public platforms!: AllPlatformCurrencyExchangeRate;
    public isManualRate = false;
    public showSyncNowButton: boolean = false;
    public stripePlans: any[] = [];
    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
        private artistService: ArtistsService,
        private artTypeService: ArtTypeService,
        private ArtistProductsService: ArtistProductsService,
        private categoryService: CategoryService,
        private seriesService: SeriesService,
        private connectionsService: ConnectionsService,
        private subscriptionRulesService: SubscriptionRulesService,
        private notificationsService: NotificationsService,
        private wooCommerceService: WoocomerceService,
        private shopifyService: ShopifyService,
        private wixService: WixService,
        private squareService: SquareupPosService,
        private squareSpaceService: SquareSpaceService,
        private CurrencyExchangeService: CurrencyExchangeService,
        private ngxSpinnerService: NgxSpinnerService,
        private currencyPipe: CurrencyPipe,
        private Router: Router,
        private transloco: TranslocoService
    ) { }

    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
            this.route.params.subscribe(params => {
                if (params['artistId']) this.artistId = params['artistId'];
            });
        }
        if (this.authConfig.IsArtist) {
            this.isFreePlanUser = this.authService.isFreePlanUser();
            this.artistId = this.authService.getUserId();
            this.isArtist = true;
        }
        this.initDropdowns();
        this.statusFilterOptions = [
            { label: 'Available', value: 'Available' },
            { label: 'Consigned', value: 'Consigned' },
            { label: 'Sold', value: 'Sold' },
        ];
        this.currencyCode = this.authService.getCurrencyCode() || 'USD';
        if (!this.visible) this.getPrimaryArtType();
        this.checkPlatformAccounts();
    }

    private initDropdowns() {
        this.getArtistArtTypeDropdownItems(this.artistId);
        this.getArtistProductsSummaryResponse(this.artistId, this.filters, true);
        this.fetchConnectedGalleries(this.artistId, false);
    }

    private checkPlatformAccounts() {
        this.shopifyService.hasAccountOnShopify().subscribe(
            acc => this.shopifyAccount = acc,
            err => console.error(err)
        );
        this.wooCommerceService.hasAccountOnWooCommerce().subscribe(
            acc => this.wooCommerceAccount = acc,
            err => console.error(err)
        );
        this.squareSpaceService.hasAccountOnSquareSpace().subscribe(
            res => this.isSquareSpaceAccountExists = !!res.Success,
            err => this.isSquareSpaceAccountExists = false
        );
    }

    // UI Actions
    public onCloseStripePaymentDailog(val: boolean) { this.isStripeDisplayPlansDialogVisible = val; }
    public onUpgradeAccount() { this.isStripeDisplayPlansDialogVisible = true; }
    public onShowWoocommerceAccountDailog() { this.isAddWoocommerceAccountDailogVisible = true; }
    public onCloseWoocommerceAccountDailog(val: boolean) { this.isAddWoocommerceAccountDailogVisible = val; }
    public onShowShopifyAccountDialog() { this.isShopifyConnectionDailogVisible = true; }
    public onCloseShopifyConnectionDailog(val: boolean) { this.isShopifyConnectionDailogVisible = val; }
    public onClosePlatformDialog() { this.selectedPlatformDailaog = false; this.resetPlatformSelection('WooCommerce'); this.resetPlatformSelection('Shopify'); }
    public onPlatformDialogHide() { this.resetPlatformSelection('WooCommerce'); this.resetPlatformSelection('Shopify'); }

    // Platform selection
    public onWoocommerceStoreChange(event: any) { this.selectedWoocommerceStore = event.value; this.updatePlatformsToSend(); }
    public onShopifyStoreChange(event: any) { this.selectedShopifyStore = event.value; this.updatePlatformsToSend(); }
    // Update the SquareSpace selection method
    public onSquareSpaceSelected(siteId: string): void {
        this.squareSpaceSiteId = siteId;
        this.squareSpacePageId = '';
        if (siteId) {
            this.loadingSquareSpacePages = true;
            this.squareSpaceService.getSquareSpaceStorePages(siteId).subscribe({
                next: (res: any) => {
                    this.loadingSquareSpacePages = false;
                    if (res.Success) {
                        this.squareSpaceSitePageDetails = res.ResponseData.storePages;
                    } else {
                        this.squareSpaceSitePageDetails = [];
                    }
                },
                error: () => {
                    this.loadingSquareSpacePages = false;
                    this.squareSpaceSitePageDetails = [];
                }
            });
        } else {
            this.squareSpaceSitePageDetails = [];
        }

        this.checkSyncNowVisibility();
    }
    // Platform dialog
    public onSyncArtworksClick(): void {
        if (this.isFreePlanUser) {
            this.isStripeDisplayPlansDialogVisible = true;
            return;
        }
        this.selectedPlatformDailaog = true;
        this.getAllAccountDetails();
    }
    public getAllAccountDetails() {
        this.getWoocommerceAccountDetail();
        this.getShopifyAccounts();
        this.getSquareSpaceAccountDetails();
    }

    private getWoocommerceAccountDetail() {
        this.isLoading = true;
        this.ngxSpinnerService.show();
        this.wooCommerceService.getWoocommerceAccountDetails(false).subscribe(
            res => { this.ngxSpinnerService.hide(); this.wooCommerceAccountList = res || []; this.isLoading = false; },
            err => { this.ngxSpinnerService.hide(); this.isLoading = false; }
        );
    }

    private getShopifyAccounts() {
        this.isLoading = true;
        this.ngxSpinnerService.show();
        this.shopifyService.getShopifyAccounts().subscribe(
            res => { this.ngxSpinnerService.hide(); this.ShopifyStoreAccountList = res || []; this.isLoading = false; },
            err => { this.ngxSpinnerService.hide(); this.isLoading = false; }
        );
    }

    private getSquareSpaceAccountDetails() {
        this.squareSpaceService.getSquareSpaceAccountDetails().subscribe(
            res => this.squareSpaceSiteDetails = res as any[] || [],
            err => { }
        );
    }

    private updatePlatformsToSend() {
        this.platformsToSend = [];
        if (this.selectedWoocommerceStore) this.platformsToSend.push({ plateform: 'woocommerce', accountId: this.selectedWoocommerceStore });
        if (this.selectedShopifyStore) this.platformsToSend.push({ plateform: 'shopify', accountId: this.selectedShopifyStore });
        if (this.squareSpaceSiteId) this.platformsToSend.push({ plateform: 'SquareSpace', accountId: this.squareSpaceSiteId });
        if (this.platformsToSend.length > 0) { this.displayCurrencyDialog = true; this.fetchExchangeRates(); }
    }

    public fetchExchangeRates() {
        this.isLoading = true;
        this.CurrencyExchangeService.fetchAllPlatformCurrencyWithExchangeRate(this.platformsToSend).subscribe({
            next: (res: AllPlatformCurrencyExchangeRate) => { this.platforms = res; this.isLoading = false; },
            error: err => { this.isLoading = false; }
        });
    }

    // Product selection
    public selectInventory(product: ArtistProductSummary) {
        if (!this.selectedGalleryProductsInventory.some(item => item.Id === product.Id)) {
            this.selectedGalleryProductsInventory.push(product);
            this.selectedProduct.push(product);
            const idx = this.artistProducts.findIndex(item => item.Id === product.Id);
            if (idx !== -1) this.artistProducts.splice(idx, 1);
        }
    }

    public moveToCurrentInventory(product: ArtistProductSummary) {
        const idx = this.selectedGalleryProductsInventory.findIndex(item => item.Id === product.Id);
        if (idx !== -1) {
            const removed = this.selectedGalleryProductsInventory.splice(idx, 1)[0];
            this.selectedProduct = this.selectedProduct.filter(item => item.Id !== removed.Id);
            this.artistProducts.push(removed);
        }
    }

    // Sync
    public acceptConsignmentProducts(_: MouseEvent | null): void {
        const productIds = this.selectedGalleryProductsInventory.map(p => p.Id).filter(Boolean);
        if (productIds.length === 0) { this.displayCurrencyDialog = false; return; }
        let squareSpaceAccountInfo: any = {};
        if (this.squareSpaceSiteId && this.squareSpacePageId) squareSpaceAccountInfo = { id: this.squareSpaceSiteId, pageId: this.squareSpacePageId };
        this.ngxSpinnerService.show();
        this.ArtistProductsService.syncArtistproducts(
            this.selectedWoocommerceStore || null,
            this.selectedShopifyStore || null,
            this.isManualRate,
            productIds,
            squareSpaceAccountInfo
        ).subscribe({
            next: (res: SyncProductsResponse) => {
                this.ngxSpinnerService.hide();
                this.resetAfterSync();
                this.prepareSyncResults(res);
                this.showSyncResultsDialog = true;
            },
            error: () => {
                this.ngxSpinnerService.hide();
                this.notificationsService.showNotification(this.transloco.translate('syncProductsArtist.errorTitle'), this.transloco.translate('syncProductsArtist.syncFailedRetry'), NotificationTypes.Error);
            },
            complete: () => {
                this.displayCurrencyDialog = false;
                this.selectedPlatformDailaog = false;
            }
        });
    }

    private prepareSyncResults(response: SyncProductsResponse) {
        this.syncResults = {
            overallSuccess: response.ResponseObject.Success,
            overallMessage: response.ResponseObject.ResponseMessage,
            platforms: []
        };
        if (response.Shopify) this.syncResults.platforms.push(this.processPlatformResponse('Shopify', response.Shopify));
        if (response.WooCommerce) this.syncResults.platforms.push(this.processPlatformResponse('WooCommerce', response.WooCommerce));
        if (response.SquareSpace) this.syncResults.platforms.push(this.processPlatformResponse('SquareSpace', response.SquareSpace));
    }

    private processPlatformResponse(platformName: string, result: PlatformSyncResult) {
        const newSyncedCount = result.SyncedProducts?.length || 0;
        const existingSyncedCount = result.AlreadySyncedProducts?.length || 0;
        const success = result.ResponseObject?.Success ?? false;
        const hasWarnings = (!success && existingSyncedCount > 0) ||
            (success && existingSyncedCount > 0 && newSyncedCount > 0);
        let message = result.ResponseObject?.ResponseMessage;
        if (!message) {
            if (success) {
                message = newSyncedCount > 0
                    ? existingSyncedCount > 0
                        ? this.transloco.translate('syncProductsArtist.someSyncedSomeUpToDate')
                        : this.transloco.translate('syncProductsArtist.productsSyncedSuccessfully')
                    : this.transloco.translate('syncProductsArtist.allAlreadySynced');
            } else {
                message = hasWarnings
                    ? this.transloco.translate('syncProductsArtist.someCouldNotSync')
                    : this.transloco.translate('syncProductsArtist.failedToSync');
            }
        }
        return { name: platformName, success, hasWarnings, message, newSyncedCount, existingSyncedCount };
    }

    private resetAfterSync() {
        this.selectedGalleryProductsInventory = [];
        this.selectedProduct = [];
        this.resetSelectedData();
        this.resetPlatformSelection('WooCommerce');
        this.resetPlatformSelection('Shopify');
        this.refreshAllProducts();
    }

    private refreshAllProducts() {
        this.loadingArtistProducts = true;
        this.ArtistProductsService.getArtistProductsSummaryResponse(this.artistId, {}).subscribe(
            (artistProducts: ArtistProductSummary[]) => {
                this.artistProducts = artistProducts
                    .filter(p => !p.IsSold && !p.IsConsignedProduct)
                    .map(product => {
                        product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
                        if (product.ArtistRevenue) product.FormattedArtistRevenue = this.currencyPipe.transform(product.ArtistRevenue, 'USD', 'symbol', '1.2-2');
                        return product;
                    });
                this.currentAvailableArtworks = this.artistProducts.length;
                this.loadingArtistProducts = false;
            },
            () => { this.loadingArtistProducts = false; }
        );
    }

    private resetPlatformSelection(platform: 'WooCommerce' | 'Shopify' | 'SquareSpace') {
        if (platform === 'WooCommerce') this.selectedWoocommerceStore = '';
        if (platform === 'Shopify') this.selectedShopifyStore = '';
        this.updatePlatformsToSend();
    }

    private resetSelectedData() {
        this.selectedProduct = [];
        this.selectedGalleryProductsInventory = [];
    }

    // Dropdowns & filters
    private getArtistArtTypeDropdownItems(artistId: string) {
        this.artistArtTypes = [];
        this.artistService.getArtistArtTypeDropdownItems(artistId).subscribe(
            (items: SelectItem[]) => this.artistArtTypes = items,
            err => { }
        );
    }
    private getAllCategoies(artTypeId: string) {
        this.productCategories = [];
        this.categoryService.fetchCategory(artTypeId).subscribe(
            cats => this.productCategories = cats.map(item => ({ label: item.Name, value: item.Id })),
            err => { }
        );
    }
    private getAllSeries(artTypeId: string) {
        this.productSeries = [];
        this.seriesService.getAllSeries(artTypeId).subscribe(
            series => this.productSeries = series.map(item => ({ label: item.Name, value: item.Id })),
            err => { }
        );
    }
    public onArtTypedChanged($event: SelectItem) {
        this.filters.ArtTypeId = $event.value;
        if (!this.filters.ArtTypeId) {
            this.filters.ProductSeriesId = undefined;
            this.filters.ProductCategory = undefined;
            this.productSeries = [];
            this.productCategories = [];
        } else {
            this.getAllSeries(this.filters.ArtTypeId);
            this.getAllCategoies(this.filters.ArtTypeId);
        }
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    private fetchConnectedGalleries(artistId: string, includeInvited: boolean) {
        this.connectionsService.getConnectedGalleries(artistId, includeInvited).subscribe(
            galleries => this.galleries = galleries.map(g => ({ label: g.Name, value: g.Id })),
            err => { }
        );
    }
    public onProductCategoriesChange($event: SelectItem) {
        this.filters.ProductCategory = $event.value;
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    public onProductSeriesChange($event: SelectItem) {
        this.filters.ProductSeriesId = $event.value;
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    public onGalleriesChange($event: SelectItem) {
        this.filters.GalleryId = $event.value;
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    public onStatusFilterChange(_: any) {
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    public clearAllFilters(_: any) {
        this.filters = {};
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    public onGlobalFilterProduct(_: any): void {
        if (!this.filters.Query || this.filters.Query.length === 0 || this.filters.Query.length >= 3) {
            this.getArtistProductsSummaryResponse(this.artistId, this.filters);
        }
    }
    private getPrimaryArtType() {
        this.artTypeService.getPrimaryArtType().subscribe(
            (primaryArtType: SelectItem) => {
                if (primaryArtType) {
                    this.artistArtTypes = [primaryArtType, ...this.artistArtTypes];
                    this.filters.ArtTypeId = primaryArtType.value;
                    this.getAllCategoies(primaryArtType.value);
                    this.getAllSeries(primaryArtType.value);
                }
            },
            err => { }
        );
    }
  private getArtistProductsSummaryResponse(artistId: string, filters: ArtistProductsSummaryRequest, isInitialCall = false) {
    this.loadingArtistProducts = true;
    
    // Ensure filters include pageSize of 1000 and status filter for available products
    const updatedFilters: ArtistProductsSummaryRequest = {
        ...filters,
        status: 'Available' // Explicitly filter for available products
    };

    this.ArtistProductsService.getArtistProductsSummaryResponse(artistId, updatedFilters).subscribe(
        (artistProducts: ArtistProductSummary[]) => {
            this.artistProducts = artistProducts
                .filter(p => !p.IsSold && !p.IsConsignedProduct)
                .map(product => {
                    product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
                    if (product.ArtistRevenue) product.FormattedArtistRevenue = this.currencyPipe.transform(product.ArtistRevenue, 'USD', 'symbol', '1.2-2');
                    return product;
                });
            if (isInitialCall) this.currentAvailableArtworks = this.artistProducts.length;
            this.loadingArtistProducts = false;
        },
        err => { this.loadingArtistProducts = false; }
    );
}


    public checkSyncNowVisibility(): void {
        this.showSyncNowButton = !!(
            this.selectedWoocommerceStore ||
            this.selectedShopifyStore ||
            this.squareSpacePageId
        );
    }

    public onChangeSquareSpacePage(event: any): void {
        this.squareSpacePageId = event.value;
    }


    public onConnectSquareSpaceAccount() {
        this.Router.navigate(['/connect-with-squarespace-account']);
    }

    // Toggle radio buttons (select/unselect)
    public toggleRadio(platform: string, id: string): void {
        switch (platform) {
            case 'woocommerce':
                this.selectedWoocommerceStore = id;
                break;
            case 'shopify':
                this.selectedShopifyStore = id;
                break;
            case 'squarespace':
                this.squareSpaceSiteId = id;
                if (!this.squareSpaceSiteId) this.squareSpacePageId = '';
                break;
        }
    }
    // Check if any store is selected
    public hasSelectedStore(): boolean {
        return !!(
            (this.selectedWoocommerceStore && this.selectedWoocommerceStore !== '') ||
            (this.selectedShopifyStore && this.selectedShopifyStore !== '') ||
            (this.squareSpaceSiteId && this.squareSpaceSiteId !== '')
        );
    }


    // Update the canSync method to properly check SquareSpace
    public canSync(): boolean {
        const hasWooCommerce = !!this.selectedWoocommerceStore && this.selectedWoocommerceStore !== '';
        const hasShopify = !!this.selectedShopifyStore && this.selectedShopifyStore !== '';
        const hasSquareSpaceSite = !!this.squareSpaceSiteId && this.squareSpaceSiteId !== '';
        const hasSquareSpacePage = !!this.squareSpacePageId;

        // If SquareSpace is selected (even partially), require both site + page
        if (hasSquareSpaceSite) {
            return hasSquareSpacePage; // Button enabled only if page is selected
        }
        // Otherwise, check if WooCommerce or Shopify is selected
        return hasWooCommerce || hasShopify;
    }
    // Reset dialog when closed
    public resetPlatformDialog(): void {
        this.selectedWoocommerceStore = '';
        this.selectedShopifyStore = '';
        this.squareSpaceSiteId = '';
        this.squareSpacePageId = '';
        this.squareSpaceSitePageDetails = [];
        this.loadingSquareSpacePages = false;
        this.platformsToSend = [];
    }

    // Update your existing onSyncNowClick method
    public onSyncNowClick(): void {
        if (this.canSync()) {
            this.updatePlatformsToSend();
        }
    }


     // Properties for product dialog
  public showProductDialog = false;
  public productId: string | null = null;
  // Handle toggle mode change

      // Open product dialog with specified product ID
  openProductDialog(productId: string) {
    this.productId = productId;
    this.showProductDialog = true;
  }

   // Close product dialog and reset product ID
  closeProductDialog() {
    this.showProductDialog = false;
    this.productId = null;
  }
}